<template>
  <div>
    <el-row v-for="(chart, index) in $root.unusedChartF2FList" :key="index">
      <div @click="OnRemove(chart.name)">
        <el-card shadow="always">
          {{ chart.displayName }}
        </el-card>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "RealTimeF2FSettingMenu",
  methods: {
    OnRemove(title) {
      let list = this.$root.unusedChartF2FList;
      for (let index in list) {
        if (list[index].name === title) {
          this.$root.usedChartF2FList.push(
            this.$root.unusedChartF2FList[index]
          );
          this.$root.unusedChartF2FList.splice(index, 1);
        }
      }
      localStorage.setItem('usedChartF2FList', JSON.stringify(this.$root.usedChartF2FList))
      if (this.$root.usedChartF2FList.length <= 5) {
        this.$root.barscrollFlg = "false";
      } else {
        this.$root.barscrollFlg = "true";
      }
      
    },
  },
};
</script>


<style>
</style>
